import { render, staticRenderFns } from "./BaseDocIcon.vue?vue&type=template&id=0af3ad28"
import script from "./BaseDocIcon.vue?vue&type=script&lang=js"
export * from "./BaseDocIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports